const { getById } = require( "@/utilities/querySelector" );

const particleWrapper = getById( 'particle-wrapper' );


function pop( e ) {
    let amount = 5;

    // Quick check if user clicked the button using a keyboard
    if ( e.clientX === 0 && e.clientY === 0 ) {
        const button = e.target.closest( '.button' );
        if ( !button ) return;
        const bounds = button.getBoundingClientRect();
        const x = bounds.left + bounds.width / 2;
        const y = bounds.top + bounds.height / 2;
        for ( let i = 0; i < amount; i++ ) {
            createParticle( x, y );
        }
    } else {
        for ( let i = 0; i < amount; i++ ) {
            createParticle( e.clientX, e.clientY );
        }
    }
}


/**
 * @param {number} x
 * @param {number} y
 *
 * @return void
 */
function createParticle( x, y ) {
    const particle = document.createElement( 'particle' );
    let size = Math.floor( Math.random() * 10 + 5 );
    let destinationX = ( Math.random() - 0.5 ) * 100;
    let destinationY = ( Math.random() - 0.5 ) * 100;
    let delay = Math.random() * 100;

    const color = `hsl(${( Math.random() - 0.5 ) * 30 + 334}, 80%, 55%)`;
    particle.style.background = color;
    particle.style.borderRadius = '50%';
    particle.style.width = `${size}px`;
    particle.style.height = `${size}px`;

    particleWrapper.appendChild( particle );

    const animation = particle.animate( [
        {
            transform: `translate(-50%, -50%) translate(${x}px, ${y}px)`,
            opacity: 1
        },
        {
            transform: `translate(-50%, -50%) translate(${x + destinationX}px, ${y + destinationY}px)`,
            opacity: 0
        }
    ], {
        duration: Math.random() * 1000 + 500,
        easing: 'cubic-bezier(0, .9, .57, 1)',
        delay: delay
    } );

    animation.onfinish = removeParticle;
}


function removeParticle( e ) {
    e.srcElement.effect.target.remove();
}


if ( document.body.animate ) {
    document.addEventListener( 'click', ( e ) => {
        pop( e );
    } );
}